import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, isRef as _isRef, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, createBlock as _createBlock, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-03093d32"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "row"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "Selection", -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "Status", -1))
const _hoisted_4 = ["value"]
const _hoisted_5 = /*#__PURE__*/_createStaticVNode("<div class=\"row\" data-v-03093d32><div class=\"separator2\" data-v-03093d32></div><div class=\"separator2\" data-v-03093d32></div><div class=\"separator\" data-v-03093d32></div><div class=\"separator\" data-v-03093d32></div></div>", 1)
const _hoisted_6 = {
  class: "pagefoot col-12",
  style: {"height":"100px","background-color":"#414e70"}
}
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-trash-alt" }, null, -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-arrow-circle-right" }, null, -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "far fa-edit" }, null, -1))

import { onMounted, ref } from "vue";
import { useStore } from 'vuex';

import SearchForm from "../components/SearchForm.vue";
import PaginationComp from '../components/PaginationComp.vue'
import WorklistEdit from "../components/worklist/WorklistEdit.vue";
import WorklistDelete from "../components/worklist/WorklistDelete.vue";
import { Worklist } from '../components/worklist/Worklist';
import { DICOM2Date, DICOM2Time } from "../components/common/routines";


export default /*#__PURE__*/_defineComponent({
  __name: 'WorklistPage',
  setup(__props) {

const store = useStore();

var results = ref<Worklist[]>([]);
var selectedEntries = ref<Worklist[]>([]);
var editModal = ref(false);
var deleteModal = ref(false);
var admin = ref(false);
var manager = ref(false);
var currentPage = ref(1);
var totalItems = ref(0);
var perPage = ref(10);

function closeModal() {
  //  console.log("Worklist: closeModal");
  selectedEntries.value = [];
  editModal.value = false;
  deleteModal.value = false;
  getWorklist("");
}

function onPerPage(pPage: number) {
  perPage.value = pPage;
  currentPage.value = 1;
}

function onPageChange(page: number) {
  currentPage.value = page;
}

function openEditDialog() {
  if (selectedEntries.value.length > 0) {
    editModal.value = true;
  } else {
    alert("ERROR, No selected Entries!");
  }
}

function openAddNewDialog() {
  selectedEntries.value = [];
  editModal.value = true;
}

function openDeleteDialog() {
  // console.log("Worklist", this.selectedEntries);
  if (selectedEntries.value.length > 0) {
    deleteModal.value = true;
  } else {
    alert("ERROR, No selected studies!");
  }
}

async function getWorklist(query: string) {
  var url = "worklist" + query;

  const data = await store.dispatch('HTTPGet', { url: url });
  if (data != null) {
    results.value = data;
    totalItems.value = results.value.length;
  } else {
    totalItems.value = 0;
  }
}

function Slice() {
  let from = (currentPage.value - 1) * perPage.value;
  let to = (currentPage.value) * perPage.value;
  return results.value.slice(from, to);
}

onMounted(async () => {
  if(store.state.authentication){
    await store.dispatch("HTTPLogin");

    if (store.state.tokenValue.length > 0) {
      getWorklist("");
      admin.value = (store.state.userRole == 1);
      manager.value = (store.state.userRole == 4);
    } else {
      location.href = "/";
      //    location.reload();
    }
  } else {
    getWorklist("");
  }
})

return (_ctx: any,_cache: any) => {
  const _component_nav_bar = _resolveComponent("nav-bar")!
  const _component_footer_bar = _resolveComponent("footer-bar")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_nav_bar, { title: "Worklist" }),
    _createVNode(SearchForm, {
      onQueryData: getWorklist,
      worklist: true
    }),
    (_unref(results))
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", null, [
            _createElementVNode("table", null, [
              _createElementVNode("tr", null, [
                _hoisted_2,
                _createElementVNode("th", null, _toDisplayString(_ctx.$t("Study.AccessionNumber")), 1),
                _createElementVNode("th", null, _toDisplayString(_ctx.$t("Study.ID")), 1),
                _createElementVNode("th", null, _toDisplayString(_ctx.$t("Study.Name")), 1),
                _createElementVNode("th", null, _toDisplayString(_ctx.$t("Worklist.StartDateTime")), 1),
                _createElementVNode("th", null, _toDisplayString(_ctx.$t("Study.Modality")), 1),
                _createElementVNode("th", null, _toDisplayString(_ctx.$t("Study.Description")), 1),
                _hoisted_3
              ]),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(Slice(), (item, index) => {
                return (_openBlock(), _createElementBlock("tr", {
                  key: item.id
                }, [
                  _createElementVNode("td", null, [
                    _withDirectives(_createElementVNode("input", {
                      type: "checkbox",
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(selectedEntries) ? (selectedEntries).value = $event : selectedEntries = $event)),
                      value: item
                    }, null, 8, _hoisted_4), [
                      [_vModelCheckbox, _unref(selectedEntries)]
                    ]),
                    _createTextVNode(" " + _toDisplayString(index + (_unref(currentPage) - 1) * _unref(perPage) + 1) + ") ", 1)
                  ]),
                  _createElementVNode("td", null, _toDisplayString(item.id), 1),
                  _createElementVNode("td", null, _toDisplayString(item.patid), 1),
                  _createElementVNode("td", null, _toDisplayString(item.patname), 1),
                  _createElementVNode("td", null, _toDisplayString(_unref(DICOM2Date)(item.date)) + " - " + _toDisplayString(_unref(DICOM2Time)(item.time)), 1),
                  _createElementVNode("td", null, _toDisplayString(item.modality), 1),
                  _createElementVNode("td", null, _toDisplayString(item.descr), 1),
                  _createElementVNode("td", null, _toDisplayString(item.status), 1)
                ]))
              }), 128))
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    _hoisted_5,
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("button", {
        onClick: openDeleteDialog,
        class: "cnlbtn"
      }, [
        _hoisted_7,
        _createTextVNode(_toDisplayString(_ctx.$t("Common.Delete")), 1)
      ]),
      _createElementVNode("button", {
        onClick: openAddNewDialog,
        class: "okbtn"
      }, [
        _hoisted_8,
        _createTextVNode(_toDisplayString(_ctx.$t("Common.AddNew")), 1)
      ]),
      _createElementVNode("button", {
        onClick: openEditDialog,
        class: "okbtn"
      }, [
        _hoisted_9,
        _createTextVNode(_toDisplayString(_ctx.$t("Common.Edit")), 1)
      ]),
      _createVNode(PaginationComp, {
        totalItems: _unref(totalItems),
        currentPage: _unref(currentPage),
        onPerPage: onPerPage,
        onPagechanged: onPageChange
      }, null, 8, ["totalItems", "currentPage"])
    ]),
    (_unref(editModal))
      ? (_openBlock(), _createBlock(WorklistEdit, {
          key: 1,
          onClose: closeModal,
          selectedEntries: _unref(selectedEntries)
        }, null, 8, ["selectedEntries"]))
      : _createCommentVNode("", true),
    (_unref(deleteModal))
      ? (_openBlock(), _createBlock(WorklistDelete, {
          key: 2,
          onClose: closeModal,
          selectedEntries: _unref(selectedEntries)
        }, null, 8, ["selectedEntries"]))
      : _createCommentVNode("", true),
    _createVNode(_component_footer_bar, { title: "Worklist" })
  ], 64))
}
}

})